import { ActionType } from '../../types';

export const StarfishDeviceActions = {
    StarfishGatewayDeviceRegistrationStarted: () =>
        ({
            type: 'StarfishGatewayDevice/Registration/Started',
        } as const),

    StarfishGatewayDeviceRegistrationSucceeded: (message: string, data: {}, connectionString: string, id: string) =>
        ({
            type: 'StarfishGatewayDevice/Registration/Succeeded',
            payload: { message, data, connectionString, id },
        } as const),

    StarfishGatewayDeviceRegistrationFailed: (errorCode: string) =>
        ({
            type: 'StarfishGatewayDevice/Registration/Failed',
            payload: { errorCode },
        } as const),

    StarfishGatewayDeviceRegistrationUnmounted: () =>
        ({
            type: 'StarfishGatewayDevice/Registration/Unmounted',
        } as const),

    StarfishGatewayDeviceMasterData: (hasData: boolean) =>
        ({
            type: 'StarfishGatewayDevice/MasterData/Failed',
            payload: { hasData },
        } as const),

    exerthermUnitIdValidation: (unitIdValidation: boolean) =>
        ({
            type: 'SierraChildDevice/UnitIdValidation/exertherm',
            payload: { unitIdValidation },
        } as const),
    StarfishGatewayDeviceUpdateStarted: () =>
        ({
            type: 'StarfishGatewayDevice/Update/Started',
        } as const),

    StarfishGatewayDeviceUpdateSucceeded: (message: string, data: {}) =>
        ({
            type: 'StarfishGatewayDevice/Update/Succeeded',
            payload: { message, data },
        } as const),

    StarfishGatewayDeviceUpdateFailed: (errorCode: string) =>
        ({
            type: 'StarfishGatewayDevice/Update/Failed',
            payload: { errorCode },
        } as const),

    StarfishGatewayDeviceUpdateReset: () =>
        ({
            type: 'StarfishGatewayDevice/Update/Reset',
        } as const),

    StarfishChildDeviceRegistrationUnmounted: () =>
        ({
            type: 'StarfishChildDevice/Registration/Unmounted',
        } as const),

    StarfishChildDeviceUpdateStarted: () =>
        ({
            type: 'StarfishChildDevice/Update/Started',
        } as const),

    StarfishChildDeviceUpdateSucceeded: (message: string, data: {}) =>
        ({
            type: 'StarfishChildDevice/Update/Succeeded',
            payload: { message, data },
        } as const),

    StarfishChildDeviceUpdateFailed: (errorCode: string) =>
        ({
            type: 'StarfishChildDevice/Update/Failed',
            payload: { errorCode },
        } as const),

    StarfishChildDeviceUpdateReset: () =>
        ({
            type: 'StarfishChildDevice/Update/Reset',
        } as const),
    deviceDeleteSucceeded: (message: string) =>
        ({
            type: 'Device/Delete/Succeeded',
            payload: { message },
        } as const),

    deviceDeleteFailed: (errorCode: string) =>
        ({
            type: 'Device/Delete/Failed',
            payload: { errorCode },
        } as const),

    DeleteStarfishGatewayStarted: () =>
        ({
            type: 'DeleteStarfishGateway/Delete/Started',
            payload: {},
        } as const),
    DeleteStarfishGatewaySucceeded: (message: string) =>
        ({
            type: 'DeleteStarfishGateway/Delete/Succeeded',
            payload: { message },
        } as const),

    DeleteStarfishGatewayFailed: (errorCode: string) =>
        ({
            type: 'DeleteStarfishGateway/Delete/Failed',
            payload: { errorCode },
        } as const),

    DeleteStarfishChildDeviceStarted:()=>
    ({
        type: 'DeleteStarfishChildDevice/Delete/Started',
            payload: {},
        } as const),
    DeleteStarfishChildDeviceSucceeded: (message: string) =>
    ({
        type: 'DeleteStarfishChildDevice/Delete/Succeeded',
            payload: { message },
        } as const),

    DeleteStarfishChildDevicesFailed: (errorCode: string) =>
    ({
        type: 'DeleteStarfishChildDevice/Delete/Failed',
            payload: { errorCode },
        } as const),


};

export type StarfishDeviceActions = ActionType<typeof StarfishDeviceActions>;
